import _clamp from 'lodash/clamp';

/**
 * Clamps value into 0..1 range
 *
 * @param {number} value
 * @returns {number} value in 0..1 range
 */
export const safeProgressValue = value => _clamp(value, 0, 1);

/**
 * Converts 0..100 progress values into 0..1 range
 *
 * @param {Number} percentage
 * @returns {Number} down-scaled progress value
 */
export const getProgress = percentage => (Number.isFinite(percentage) ? percentage / 100 : 0);

export const getPercentage = (currentTime, clipDuration) =>
  clipDuration && currentTime ? Math.ceil((currentTime * 100) / clipDuration) : 0;

/**
 * Converts 0..100 progress values into ProgressBar data
 *
 * @param {Number} percentage
 * @returns {object} progress bar data
 */
export const makeProgressBarProperties = percentage => {
  const progress = getProgress(percentage);

  return {
    visible: Boolean(progress),
    progress,
  };
};
